// Module
var code = `<div class="onetime-dialog-container">
    <!-- Dialog Header -->
    <div class="onetime-dialog-header">
        <h1 id="onetimeDuplicatePaymentAlert">Duplicate Payment Alert</h1>
    </div>
    <!-- Dialog Content -->
    <div class="onetime-dialog-content onetime-scrollable-content">
        <p id="onetimeAlertDescription"> There is a payment pending on this account for {{currentDate.format('MM/dd/yyyy') }} for \${{amount}} with the confirmation # of {{vendorItemNumber}} </p>
        <p class="onetime-proceed-question">Would you like to proceed?</p>
    </div>
    <!-- Dialog Footer -->
    <div class="onetime-dialog-footer">  <button class="onetime-button onetime-button-primary" (click)="closeThisDialog(true)" aria-label="Proceed with duplicate payment"> Yes </button> <button class="onetime-button onetime-button-secondary" (click)="closeThisDialog(false)" aria-label="Cancel duplicate payment"> No </button></div>
     <p class="duplicate-payment-warning"> Selecting yes will allow you to complete this payment but may result in a duplicate payment.</p>
</div>
`;
// Exports
module.exports = code;